import styled, { css } from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
`;

export const Title = styled.h3`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    gap: 8px;
    font-family: ${theme.v3.font.family.brand};
    font-size: ${theme.v3.font.sizes['1xmedium']};
    font-weight: ${theme.v3.font.weights.medium};
    line-height: ${theme.v3.font.lineHeight.comfortable};
    color: ${theme.v3.colors.neutral[30]};
    margin: 0;
  `};
`;

export const Count = styled.span`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    padding: 2px 8px;
    background: ${theme.v3.colors.brand.snappyBlue[95]};
    font-family: ${theme.v3.font.family.brand};
    font-size: ${theme.v3.font.sizes.small};
    font-weight: ${theme.v3.font.weights.medium};
    line-height: ${theme.v3.font.lineHeight.comfortable};
    color: ${theme.v3.colors.brand.snappyBlue[10]};
    margin: 0;
  `};
`;

export const Items = styled.div`
  ${({ theme }) => css`
    display: grid;
    grid-template-columns: repeat(1, 1fr);
    flex-wrap: wrap;
    list-style: none;
    padding: 0;
    margin: 0;
    width: 100%;
    gap: 16px;

    @media (min-width: ${theme.v3.breakpoints.lg}) {
      grid-template-columns: repeat(2, 1fr);
    }
 
    @media (min-width: ${theme.v3.breakpoints.lgg}) {
      grid-template-columns: repeat(3, 1fr);
    }
  `};
`;

export const Item = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 24px;
    gap: 16px;
    border: 1px solid ${theme.v3.colors.neutral[90]};
    border-radius: 16px;  
    min-width: 0;

    @media (max-width: ${theme.v3.breakpoints.md}) {
      flex-direction: column;
    }
  `};
`;

export const ItemInfo = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: flex-start;
    justify-content: center;
    flex-direction: column;
    gap: 8px;

    @media (max-width: ${theme.v3.breakpoints.md}) {
      width: 100%;
    }
  `};    
`;

export const ItemName = styled.p`
  ${({ theme }) => css`
    font-family: ${theme.v3.font.family.brand};
    font-size: ${theme.v3.font.sizes.medium};
    font-weight: ${theme.v3.font.weights.medium};
    line-height: ${theme.v3.font.lineHeight.comfortable};
    color: ${theme.v3.colors.neutral[20]};
    margin: 0;
    max-width: 300px;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;  
    overflow: hidden;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    word-break: break-all;
    overflow-wrap: anywhere;

    @media (min-width: ${theme.v3.breakpoints.md}) {
      max-width: 200px;      
    }
 
    @media (min-width: ${theme.v3.breakpoints.xl}) {
      max-width: 300px;      
    }    
  `};
`;

export const ItemCreatedAt = styled.p`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    gap: 4px;
    font-family: ${theme.v3.font.family.brand};
    font-size: ${theme.v3.font.sizes.small};
    font-weight: ${theme.v3.font.weights.regular};
    color: ${theme.v3.colors.neutral[30]};
    margin: 0;
    white-space: nowrap;
  `};
`;

export const ItemActions = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;

    @media (max-width: ${theme.v3.breakpoints.md}) {
      width: 100%;
      justify-content: flex-end;
    }  
  `};
`;

export const ItemActionButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px;
  border-radius: 4px;
  border: none;
  background: transparent;
  cursor: pointer;

  &:hover {
    background-color: ${({ theme }) => theme.v3.colors.neutral[95]};
  }
`;
